module.exports = __webpack_public_path__ + "static/media/gu.6fc7b410.svg";